exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".user-chatlog[data-v-de665840]{border:1px solid #ececec;padding:5px;min-height:300px;max-height:300px;margin-bottom:3px;overflow-x:hidden;overflow-y:scroll}.member-info[data-v-de665840]{text-align:right}.chat-support-message[data-v-de665840]{color:#242322;background-color:#f2f6f9;width:-moz-fit-content;width:fit-content;display:block;margin-top:3px;position:relative;padding:7px 12px}.member-message-container[data-v-de665840]{position:relative;float:right}.member-message[data-v-de665840]{color:#242322;background-color:#dbf4fc;width:-moz-fit-content;width:fit-content;display:block;margin-top:5px;padding:7px 22px}", ""]);

// exports
